module.exports = __webpack_public_path__ + "28b67065/img/saly-icon.39e12342.jpg";